import { experience, profile, stats } from '../data/content';
import { SectionHeading } from './SectionHeading';

export function About() {
  return (
    <section className="section-band" id="about">
      <div className="container">
        <SectionHeading
          eyebrow="About Me"
          title="About me"
          text="Focus on simple, clean code and understandable results for websites, applications, and game projects."
        />

        <div className="about-layout">
          <div className="about-copy reveal">
            <p>{profile.headline}</p>
            <p>
              I work with C#, HTML, CSS, JavaScript, and Python. I can create a website, a small application,
              a game prototype, or a state system for orders, statuses, and simple dashboard flows.
            </p>
          </div>

          <div className="stats-grid reveal">
            {stats.map((stat) => (
              <div className={`stat-card tone-${stat.tone}`} key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="experience-grid">
          {experience.map((item) => {
            const Icon = item.icon;
            return (
              <article className="experience-card reveal" key={item.title}>
                <div className="card-icon">
                  <Icon size={22} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
